import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCapturedTextCopied.meta';

export type UseTrackCapturedTextCopiedParams = {
  text_id: string;
  text: string;
};

export const useTrackCapturedTextCopied = () => {
  const { track } = useAnalyticsUtilities();

  const trackCapturedTextCopied = useCallback(
    (params: UseTrackCapturedTextCopiedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCapturedTextCopied };
};
